// Vendor libraries
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// Modules
import { HelpModalModule } from 'NewAngular/features/components/modals/help-modal/help-modal.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { SingleSelectDropdownModule } from 'NewAngular/features/components/dropdowns/single-select-dropdown/single-select-dropdown.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import * as i0 from "@angular/core";
export class ChartsSharedModule {
}
ChartsSharedModule.ɵfac = function ChartsSharedModule_Factory(t) { return new (t || ChartsSharedModule)(); };
ChartsSharedModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ChartsSharedModule });
ChartsSharedModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, FormsModule, HelpModalModule, IconModule, SingleSelectDropdownModule, TooltipModule] });
